import {Component} from '@angular/core';
/**
 * \@title Datepicker start date
 */
export class DatepickerStartViewExample {
  startDate = new Date(1990, 0, 1);
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'datepicker-start-view-example',
  templateUrl: 'datepicker-start-view-example.html',
  styleUrls: ['datepicker-start-view-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatepickerStartViewExample_tsickle_Closure_declarations() {
/** @type {?} */
DatepickerStartViewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatepickerStartViewExample.ctorParameters;
/** @type {?} */
DatepickerStartViewExample.prototype.startDate;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
